/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type CreateDirectoryContact201Response,
    CreateDirectoryContact201ResponseFromJSON,
    CreateDirectoryContact201ResponseToJSON,
} from '../models/CreateDirectoryContact201Response';
import {
    type CreateDirectoryContactRequest,
    CreateDirectoryContactRequestFromJSON,
    CreateDirectoryContactRequestToJSON,
} from '../models/CreateDirectoryContactRequest';
import {
    type CreateFacilityPhysician201Response,
    CreateFacilityPhysician201ResponseFromJSON,
    CreateFacilityPhysician201ResponseToJSON,
} from '../models/CreateFacilityPhysician201Response';
import {
    type CreateFacilityPhysician400Response,
    CreateFacilityPhysician400ResponseFromJSON,
    CreateFacilityPhysician400ResponseToJSON,
} from '../models/CreateFacilityPhysician400Response';
import {
    type DeleteFacilityPhysician200Response,
    DeleteFacilityPhysician200ResponseFromJSON,
    DeleteFacilityPhysician200ResponseToJSON,
} from '../models/DeleteFacilityPhysician200Response';
import {
    type FacilityPhysicianInput,
    FacilityPhysicianInputFromJSON,
    FacilityPhysicianInputToJSON,
} from '../models/FacilityPhysicianInput';
import {
    type FindAllStateTowns200Response,
    FindAllStateTowns200ResponseFromJSON,
    FindAllStateTowns200ResponseToJSON,
} from '../models/FindAllStateTowns200Response';
import {
    type FindAllStates200Response,
    FindAllStates200ResponseFromJSON,
    FindAllStates200ResponseToJSON,
} from '../models/FindAllStates200Response';
import {
    type ListDirectoryContacts200Response,
    ListDirectoryContacts200ResponseFromJSON,
    ListDirectoryContacts200ResponseToJSON,
} from '../models/ListDirectoryContacts200Response';
import {
    type ListEligibleDirectoryContactUsers200Response,
    ListEligibleDirectoryContactUsers200ResponseFromJSON,
    ListEligibleDirectoryContactUsers200ResponseToJSON,
} from '../models/ListEligibleDirectoryContactUsers200Response';
import {
    type ProviderDirectoryContactType,
    ProviderDirectoryContactTypeFromJSON,
    ProviderDirectoryContactTypeToJSON,
} from '../models/ProviderDirectoryContactType';
import {
    type SetDefaultFacilityPhysician200Response,
    SetDefaultFacilityPhysician200ResponseFromJSON,
    SetDefaultFacilityPhysician200ResponseToJSON,
} from '../models/SetDefaultFacilityPhysician200Response';
import {
    type SetDefaultFacilityPhysicianRequest,
    SetDefaultFacilityPhysicianRequestFromJSON,
    SetDefaultFacilityPhysicianRequestToJSON,
} from '../models/SetDefaultFacilityPhysicianRequest';
import {
    type UpdateDirectoryContactRequest,
    UpdateDirectoryContactRequestFromJSON,
    UpdateDirectoryContactRequestToJSON,
} from '../models/UpdateDirectoryContactRequest';
import {
    type UpdateFacilityPhoneRequest,
    UpdateFacilityPhoneRequestFromJSON,
    UpdateFacilityPhoneRequestToJSON,
} from '../models/UpdateFacilityPhoneRequest';

export interface CreateDirectoryContactOperationRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    createDirectoryContactRequest: CreateDirectoryContactRequest;
}

export interface CreateFacilityPhysicianRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    facilityPhysicianInput: FacilityPhysicianInput;
}

export interface DeleteDirectoryContactRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    contactId: string;
}

export interface DeleteFacilityPhysicianRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    physicianId: string;
}

export interface FindAllStateTownsRequest {
    /**
     * 
     */
    stateId: string;
    /**
     * 
     */
    ids?: string;
    /**
     * 
     */
    search?: string;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    page?: number;
}

export interface ListDirectoryContactsRequest {
    /**
     * 
     */
    id: string;
}

export interface ListEligibleDirectoryContactUsersRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    contactType: ProviderDirectoryContactType;
}

export interface SetDefaultFacilityPhysicianOperationRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    setDefaultFacilityPhysicianRequest: SetDefaultFacilityPhysicianRequest;
}

export interface UpdateDirectoryContactOperationRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    contactId: string;
    /**
     * 
     */
    updateDirectoryContactRequest: UpdateDirectoryContactRequest;
}

export interface UpdateFacilityPhoneOperationRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    updateFacilityPhoneRequest: UpdateFacilityPhoneRequest;
}

export interface UpdateFacilityPhysicianRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    physicianId: string;
    /**
     * 
     */
    facilityPhysicianInput: FacilityPhysicianInput;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for createDirectoryContact without sending the request
     */
    async createDirectoryContactRequestOpts(requestParameters: CreateDirectoryContactOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createDirectoryContact().'
            );
        }

        if (requestParameters['createDirectoryContactRequest'] == null) {
            throw new runtime.RequiredError(
                'createDirectoryContactRequest',
                'Required parameter "createDirectoryContactRequest" was null or undefined when calling createDirectoryContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facilities/{id}/directory-contacts`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDirectoryContactRequestToJSON(requestParameters['createDirectoryContactRequest']),
        };
    }

    /**
     * Create a directory contact for a facility
     */
    async createDirectoryContactRaw(requestParameters: CreateDirectoryContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateDirectoryContact201Response>> {
        const requestOptions = await this.createDirectoryContactRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateDirectoryContact201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a directory contact for a facility
     */
    async createDirectoryContact(requestParameters: CreateDirectoryContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateDirectoryContact201Response> {
        const response = await this.createDirectoryContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createFacilityPhysician without sending the request
     */
    async createFacilityPhysicianRequestOpts(requestParameters: CreateFacilityPhysicianRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createFacilityPhysician().'
            );
        }

        if (requestParameters['facilityPhysicianInput'] == null) {
            throw new runtime.RequiredError(
                'facilityPhysicianInput',
                'Required parameter "facilityPhysicianInput" was null or undefined when calling createFacilityPhysician().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facilities/{id}/physicians`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FacilityPhysicianInputToJSON(requestParameters['facilityPhysicianInput']),
        };
    }

    /**
     * Create a physician for a facility
     */
    async createFacilityPhysicianRaw(requestParameters: CreateFacilityPhysicianRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFacilityPhysician201Response>> {
        const requestOptions = await this.createFacilityPhysicianRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFacilityPhysician201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a physician for a facility
     */
    async createFacilityPhysician(requestParameters: CreateFacilityPhysicianRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFacilityPhysician201Response> {
        const response = await this.createFacilityPhysicianRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteDirectoryContact without sending the request
     */
    async deleteDirectoryContactRequestOpts(requestParameters: DeleteDirectoryContactRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteDirectoryContact().'
            );
        }

        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling deleteDirectoryContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facilities/{id}/directory-contacts/{contactId}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{contactId}', encodeURIComponent(String(requestParameters['contactId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Soft-delete a facility directory contact
     */
    async deleteDirectoryContactRaw(requestParameters: DeleteDirectoryContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteDirectoryContactRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft-delete a facility directory contact
     */
    async deleteDirectoryContact(requestParameters: DeleteDirectoryContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDirectoryContactRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteFacilityPhysician without sending the request
     */
    async deleteFacilityPhysicianRequestOpts(requestParameters: DeleteFacilityPhysicianRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteFacilityPhysician().'
            );
        }

        if (requestParameters['physicianId'] == null) {
            throw new runtime.RequiredError(
                'physicianId',
                'Required parameter "physicianId" was null or undefined when calling deleteFacilityPhysician().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facilities/{id}/physicians/{physician_id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{physician_id}', encodeURIComponent(String(requestParameters['physicianId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Soft-delete a physician for a facility
     */
    async deleteFacilityPhysicianRaw(requestParameters: DeleteFacilityPhysicianRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteFacilityPhysician200Response>> {
        const requestOptions = await this.deleteFacilityPhysicianRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteFacilityPhysician200ResponseFromJSON(jsonValue));
    }

    /**
     * Soft-delete a physician for a facility
     */
    async deleteFacilityPhysician(requestParameters: DeleteFacilityPhysicianRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteFacilityPhysician200Response> {
        const response = await this.deleteFacilityPhysicianRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllStateTowns without sending the request
     */
    async findAllStateTownsRequestOpts(requestParameters: FindAllStateTownsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['stateId'] == null) {
            throw new runtime.RequiredError(
                'stateId',
                'Required parameter "stateId" was null or undefined when calling findAllStateTowns().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/states/{state_id}/towns`;
        urlPath = urlPath.replace('{state_id}', encodeURIComponent(String(requestParameters['stateId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get towns by state ID
     */
    async findAllStateTownsRaw(requestParameters: FindAllStateTownsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllStateTowns200Response>> {
        const requestOptions = await this.findAllStateTownsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllStateTowns200ResponseFromJSON(jsonValue));
    }

    /**
     * Get towns by state ID
     */
    async findAllStateTowns(requestParameters: FindAllStateTownsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllStateTowns200Response> {
        const response = await this.findAllStateTownsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findAllStates without sending the request
     */
    async findAllStatesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/states`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get US states
     */
    async findAllStatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllStates200Response>> {
        const requestOptions = await this.findAllStatesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllStates200ResponseFromJSON(jsonValue));
    }

    /**
     * Get US states
     */
    async findAllStates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllStates200Response> {
        const response = await this.findAllStatesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listDirectoryContacts without sending the request
     */
    async listDirectoryContactsRequestOpts(requestParameters: ListDirectoryContactsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling listDirectoryContacts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facilities/{id}/directory-contacts`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List a facility\'s directory contacts
     */
    async listDirectoryContactsRaw(requestParameters: ListDirectoryContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDirectoryContacts200Response>> {
        const requestOptions = await this.listDirectoryContactsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDirectoryContacts200ResponseFromJSON(jsonValue));
    }

    /**
     * List a facility\'s directory contacts
     */
    async listDirectoryContacts(requestParameters: ListDirectoryContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDirectoryContacts200Response> {
        const response = await this.listDirectoryContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listEligibleDirectoryContactUsers without sending the request
     */
    async listEligibleDirectoryContactUsersRequestOpts(requestParameters: ListEligibleDirectoryContactUsersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling listEligibleDirectoryContactUsers().'
            );
        }

        if (requestParameters['contactType'] == null) {
            throw new runtime.RequiredError(
                'contactType',
                'Required parameter "contactType" was null or undefined when calling listEligibleDirectoryContactUsers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['contactType'] != null) {
            queryParameters['contact_type'] = requestParameters['contactType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/facilities/{id}/directory-contacts/eligible-users`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List Exacare users eligible to be picked as a directory contact for this facility
     */
    async listEligibleDirectoryContactUsersRaw(requestParameters: ListEligibleDirectoryContactUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListEligibleDirectoryContactUsers200Response>> {
        const requestOptions = await this.listEligibleDirectoryContactUsersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListEligibleDirectoryContactUsers200ResponseFromJSON(jsonValue));
    }

    /**
     * List Exacare users eligible to be picked as a directory contact for this facility
     */
    async listEligibleDirectoryContactUsers(requestParameters: ListEligibleDirectoryContactUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListEligibleDirectoryContactUsers200Response> {
        const response = await this.listEligibleDirectoryContactUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setDefaultFacilityPhysician without sending the request
     */
    async setDefaultFacilityPhysicianRequestOpts(requestParameters: SetDefaultFacilityPhysicianOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling setDefaultFacilityPhysician().'
            );
        }

        if (requestParameters['setDefaultFacilityPhysicianRequest'] == null) {
            throw new runtime.RequiredError(
                'setDefaultFacilityPhysicianRequest',
                'Required parameter "setDefaultFacilityPhysicianRequest" was null or undefined when calling setDefaultFacilityPhysician().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facilities/{id}/physicians/default`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetDefaultFacilityPhysicianRequestToJSON(requestParameters['setDefaultFacilityPhysicianRequest']),
        };
    }

    /**
     * Set or clear the default physician for a facility
     */
    async setDefaultFacilityPhysicianRaw(requestParameters: SetDefaultFacilityPhysicianOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetDefaultFacilityPhysician200Response>> {
        const requestOptions = await this.setDefaultFacilityPhysicianRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetDefaultFacilityPhysician200ResponseFromJSON(jsonValue));
    }

    /**
     * Set or clear the default physician for a facility
     */
    async setDefaultFacilityPhysician(requestParameters: SetDefaultFacilityPhysicianOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetDefaultFacilityPhysician200Response> {
        const response = await this.setDefaultFacilityPhysicianRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateDirectoryContact without sending the request
     */
    async updateDirectoryContactRequestOpts(requestParameters: UpdateDirectoryContactOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateDirectoryContact().'
            );
        }

        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling updateDirectoryContact().'
            );
        }

        if (requestParameters['updateDirectoryContactRequest'] == null) {
            throw new runtime.RequiredError(
                'updateDirectoryContactRequest',
                'Required parameter "updateDirectoryContactRequest" was null or undefined when calling updateDirectoryContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facilities/{id}/directory-contacts/{contactId}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{contactId}', encodeURIComponent(String(requestParameters['contactId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDirectoryContactRequestToJSON(requestParameters['updateDirectoryContactRequest']),
        };
    }

    /**
     * Update a facility directory contact
     */
    async updateDirectoryContactRaw(requestParameters: UpdateDirectoryContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateDirectoryContact201Response>> {
        const requestOptions = await this.updateDirectoryContactRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateDirectoryContact201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a facility directory contact
     */
    async updateDirectoryContact(requestParameters: UpdateDirectoryContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateDirectoryContact201Response> {
        const response = await this.updateDirectoryContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateFacilityPhone without sending the request
     */
    async updateFacilityPhoneRequestOpts(requestParameters: UpdateFacilityPhoneOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateFacilityPhone().'
            );
        }

        if (requestParameters['updateFacilityPhoneRequest'] == null) {
            throw new runtime.RequiredError(
                'updateFacilityPhoneRequest',
                'Required parameter "updateFacilityPhoneRequest" was null or undefined when calling updateFacilityPhone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facilities/{id}/phone`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFacilityPhoneRequestToJSON(requestParameters['updateFacilityPhoneRequest']),
        };
    }

    /**
     * Update a facility phone number
     */
    async updateFacilityPhoneRaw(requestParameters: UpdateFacilityPhoneOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateFacilityPhoneRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a facility phone number
     */
    async updateFacilityPhone(requestParameters: UpdateFacilityPhoneOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateFacilityPhoneRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateFacilityPhysician without sending the request
     */
    async updateFacilityPhysicianRequestOpts(requestParameters: UpdateFacilityPhysicianRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateFacilityPhysician().'
            );
        }

        if (requestParameters['physicianId'] == null) {
            throw new runtime.RequiredError(
                'physicianId',
                'Required parameter "physicianId" was null or undefined when calling updateFacilityPhysician().'
            );
        }

        if (requestParameters['facilityPhysicianInput'] == null) {
            throw new runtime.RequiredError(
                'facilityPhysicianInput',
                'Required parameter "facilityPhysicianInput" was null or undefined when calling updateFacilityPhysician().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/facilities/{id}/physicians/{physician_id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{physician_id}', encodeURIComponent(String(requestParameters['physicianId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FacilityPhysicianInputToJSON(requestParameters['facilityPhysicianInput']),
        };
    }

    /**
     * Update a physician for a facility
     */
    async updateFacilityPhysicianRaw(requestParameters: UpdateFacilityPhysicianRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateFacilityPhysician201Response>> {
        const requestOptions = await this.updateFacilityPhysicianRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateFacilityPhysician201ResponseFromJSON(jsonValue));
    }

    /**
     * Update a physician for a facility
     */
    async updateFacilityPhysician(requestParameters: UpdateFacilityPhysicianRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateFacilityPhysician201Response> {
        const response = await this.updateFacilityPhysicianRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
